module.exports = __webpack_public_path__ + "static/media/report.59105c1b.png";